import { createAction } from "@reduxjs/toolkit";

const storeAllInfluencers = createAction("storeAllInfluencers");
const updateInfluencerStatus = createAction("updateInfluencerStatus");

export { updateInfluencerStatus, storeAllInfluencers };
